<div class="row row-padding">
  <div class="col-8">
    <div class="header-block" [ngStyle]="{backgroundColor: '#153054'}">
      <div class="row" style="padding:0px !important">
        <div class="col">
          <div class="col">
            <h2 class="club border-header"><i [hidden]="clubs.length < 2" (click)="showClubSelector = !showClubSelector"
                class="fas fa-caret-down"></i><span (click)="navToExplore()">{{company.companyName}}</span></h2>
            <ul [hidden]="!showClubSelector ||  clubs.length < 2" class="club-selector">
              <li *ngFor="let club of clubs; index as i" (click)="companySelected(club)">
                {{club.companyName}}
                <i *ngIf="i == 0" class="fas fa-star"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row" style="margin-left: 35px;color: white;padding:0px !important">
        <h6 class="lion-year" *ngIf="currentLionYear == thisYear">
          {{ lblCurrentLionYear }}
          {{ '7/01/' + currentLionYear | date: 'longDate' }} -
          {{ '6/30/' + (currentLionYear + 1) | date: 'longDate' }}
        </h6>
        <h6 class="lion-year" *ngIf="currentLionYear != thisYear">
          {{ '7/01/' + currentLionYear | date: 'longDate' }} -
          {{ '6/30/' + (currentLionYear + 1) | date: 'longDate' }}
        </h6>
      </div>
      <div class="row container" style="margin-top: 50px;">
        <div (click)="navToExplore()" class="col" style='text-align: center; cursor: pointer;'>
          <h2 class="margin-0">{{summary.overallNumberOfPeopleServed | number}}</h2>
          <p class="metrics-small"><span translate="lblHowManyPeopleServed">People Served</span> ></p>
        </div>
        <!--        <div (click)="navToExplore()" class="col" style='text-align: center; cursor: pointer;'>-->
        <!--          <h2 class="margin-0">{{summary.overallNumberOfPeopleServedPerMember | number}}</h2>-->
        <!--          <p class="small"><span translate="btnPeopleServedPerMember">People Served Per Member</span> ></p>-->
        <!--        </div>-->
        <div (click)="navToExplore()" class="col" style='text-align: center; cursor: pointer;'>
          <h2 class="margin-0">{{summary.overallActivityCount | number}}</h2>
          <p class="metrics-small"><span translate="btnServiceActivitiesCompleted">Service Activities Completed</span> >
          </p>
        </div>
        <div (click)="navToExplore()" class="col" style='text-align: center; cursor: pointer;'>
          <h2 class="margin-0">${{summary.overallFundsDonated == null ? 0 :( summary.overallFundsDonated >= 10000000 ?
            (summary.overallFundsDonated | shortNumber) : (summary.overallFundsDonated | number)) }}</h2>
          <p class="metrics-small"><span translate="lblFundsDonated">Funds Donated</span> ></p>
        </div>
      </div>
        <div class="home-disclaimer">
            <div (click)="openDisclaimerDialog()" class="cap-disclaimer"
            #activitiesDisclaimerElement [innerHtml]="formattedActivitiesDisclaimer"></div>
            <div (click)="openCapsDialog()" class="cap-disclaimer" #capHtmlElement [innerHtml]="formattedCapDisclaimer"></div>
        </div>
     </div>
  </div>
  <div class="col header-image" [ngStyle]="{height: '300px', backgroundImage: 'url(/assets/images/home_banner.jpg)'}">
  </div>
</div>
<div class="row ">
  <div class="col">
    <h3 translate="lblSignatureActivities">Signature Activities</h3>
  </div>
</div>
<div class="row row-padding" *ngIf="!activitiesLoaded">
  <div class="dynamic-spinner"></div>
</div>
<div class="row row-padding" *ngFor="let group of signatureActivites">
  <div class="col-auto" *ngFor="let activity of group">
    <app-activity-panel [owner]="true" [displayActionLabels]="true" [displayChip]="true" [user]="user"
      (click)="navigateToActivity(activity)" [activity]="activity"></app-activity-panel>
  </div>
</div>
<div class="row" *ngIf="!signatureActivites.length && activitiesLoaded">
  <div class="col">
    <div style="
  width: 190px;
  height: 180px;
  background-color: #ffffff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24);">
      <div class="activity-create-click" (click)="createActivity()">
        <mat-icon style="
font-size: 120px;
    color: #f6f6f6;
    margin-top: 12px;
    margin-left: 35px;
    cursor: pointer;">add_circle</mat-icon>
        <p style="text-align: center; color: #606060; font-size: 14px;" translate="lblCreateActivity">
          Create my first activity.
        </p>
      </div>
    </div>
  </div>
</div>
<div class="row ">
  <div class="col">
    <h3 translate="lblUpcomingActivitiesLC">Upcoming Activities</h3>
  </div>
</div>
<div class="row" *ngIf="!displayActivities.length && activitiesLoaded">
  <div class="col">
    <div style="
  width: 190px;
  height: 180px;
  background-color: #ffffff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24);">
      <div class="activity-create-click" (click)="createActivity()">
        <mat-icon style="
font-size: 120px;
    color: #f6f6f6;
    margin-top: 12px;
    margin-left: 35px;
    cursor: pointer;">add_circle</mat-icon>
        <p style="text-align: center; color: #606060; font-size: 14px;" translate="lblCreateActivity">
          Create my first activity.
        </p>
      </div>
    </div>
  </div>
</div>
<div class="row row-padding" *ngIf="!activitiesLoaded">
  <div class="dynamic-spinner"></div>
</div>
<div class="row row-padding" *ngFor="let group of displayActivities">
  <div class="col-auto" *ngFor="let activity of group">
    <app-activity-panel [owner]="true" [displayActionLabels]="true" [displayChip]="true" [user]="user"
      (click)="navigateToActivity(activity)" [activity]="activity"></app-activity-panel>
  </div>
</div>